import { render } from "./FatturaDettaglioPage.vue?vue&type=template&id=6ed1e903&scoped=true"
import script from "./FatturaDettaglioPage.vue?vue&type=script&lang=js"
export * from "./FatturaDettaglioPage.vue?vue&type=script&lang=js"

import "./FatturaDettaglioPage.vue?vue&type=style&index=0&id=6ed1e903&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed1e903"]])

export default __exports__